"use client"

import { useEffect, useState } from "react"
import moment from "moment"

import { checkedRestaurantClosed } from "@/lib/action"
import { useRestaurantOpenOrClose } from "@/hooks/use-restaurant-open-or-close"
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"

import { CloseRestaurantCard } from "./close-restaurant-card"

interface CloseRestaurantModalProps {
  cookieName: string | undefined
}

export function CloseRestaurantModal({
  cookieName,
}: CloseRestaurantModalProps) {
  const [isChecked, setIsChecked] = useState<boolean>(false)
  const [open, setOpen] = useState<boolean>(false)
  const [isMounted, setIsMounted] = useState<boolean>(false)
  const [restaurantWillBeOpen, setRestaurantWillBeOpen] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  })

  const { isOpen, type, times, isLoading } = useRestaurantOpenOrClose()

  useEffect(() => {
    setIsMounted(true)
  }, [])

  useEffect(() => {
    if (!isLoading && type) {
      setOpen(!isOpen)
    }
  }, [isLoading, type, times, isOpen])

  useEffect(() => {
    if (times && type === "manual") {
      const interval = setInterval(() => {
        const now = moment.utc()
        const end = moment.utc(times?.to)
        const diff = moment.duration(end.diff(now))

        const days = diff.days()
        const hours = diff.hours()
        const minutes = diff.minutes()
        const seconds = diff.seconds()

        if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) {
          return setOpen(false)
        }

        setRestaurantWillBeOpen({
          days,
          hours,
          minutes,
          seconds,
        })
      }, 1000)

      return () => clearInterval(interval)
    }
  }, [times, type])

  useEffect(() => {
    if (cookieName === "true") {
      setIsChecked(true)
    }
  }, [cookieName])

  if (!isMounted || isLoading) {
    return null
  }

  return (
    <>
      <AlertDialog
        open={open && !isChecked}
        onOpenChange={(open) => {
          setOpen(open)
          checkedRestaurantClosed("true")
        }}
      >
        <AlertDialogContent className="max-w-xl">
          <AlertDialogHeader>
            <AlertDialogTitle>Restaurant is closed</AlertDialogTitle>
            <AlertDialogDescription>
              {type === "manual"
                ? `Restaurant is currently closed for ${times?.reason}.  When the restaurant is open, you can place an order. Thank you for your patience.`
                : type === "regular"
                  ? "The restaurant is currently closed. Please check the opening hours. When the restaurant is open, you can place an order. Thank you for your patience."
                  : "The restaurant is currently closed."}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <CloseRestaurantCard
            restaurantWillBeOpen={restaurantWillBeOpen}
            type={type}
          />
          <AlertDialogFooter>
            <AlertDialogCancel>Close Popup</AlertDialogCancel>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}
